import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const OrderSummaryRowTone = {
  Neutral: 'neutral',
  Muted: 'muted',
  Success: 'success',
} as const;

export type OrderSummaryRowToneType =
  (typeof OrderSummaryRowTone)[keyof typeof OrderSummaryRowTone];

export const OrderSummaryRowEmphasis = {
  Default: 'default',
  Prominent: 'prominent',
} as const;

export type OrderSummaryRowEmphasisType =
  (typeof OrderSummaryRowEmphasis)[keyof typeof OrderSummaryRowEmphasis];

export type OrderSummaryRowProps = {
  label: string;
  value?: string;
  icon?: TUNDR_ICONS;
  tone?: OrderSummaryRowToneType;
  emphasis?: OrderSummaryRowEmphasisType;
  testId?: string;
};

export type OrderSummaryRowSlots = {
  default?: () => unknown;
};
